import React from 'react'
import {Provider as AlertProvider} from 'react-alert'
import { CookiesProvider } from 'react-cookie'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import './index.css'
import AppThemeProvider from './AppThemeProvider'
import { store } from './store'
import SystemAlert from './SystemAlert/SystemAlert'
import './i18n/i18n.js';

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
	<Provider store={ store }>
		<CookiesProvider>
			<AppThemeProvider>
				<AlertProvider
					template={SystemAlert}
					timeout={8000}
					transition={'scale'}
					offset={'100px'}
					position={'top right'}
				>
					<App/>
				</AlertProvider>
			</AppThemeProvider>
		</CookiesProvider>
	</Provider>
)
